import ShippingContent from "../components/ShippingContent/ShippingContent";
import PublicLayout from "../components/Layout/PublicLayout";

const Shipping = () => {
    return(
    <PublicLayout>
        <ShippingContent />
    </PublicLayout>
)
}

export default Shipping;

